<fc-progress-bar currentStep="6"></fc-progress-bar>
<div #container *ngIf="activeSite" class="container">
  <header class="page-header">
    <div class="fc-back-link" routerLink="/site/{{ activeSite.id }}/information-documentation">
      <fa-icon [icon]="['far', 'arrow-left']" class="gray"></fa-icon>
      <span>Back</span>
    </div>
    <div class="header-text">You're just steps away from completing your Carbon Offset Site!</div>
    <mat-divider></mat-divider>
  </header>

  <div class="buyer-header-bar">
    <ng-container *ngIf="activeSite && activeSite.cohort.buyer">
      <img
        [alt]="activeSite.cohort.buyer.name"
        [src]="getOpenAssetURL(activeSite.cohort.buyer.shortName, 'logo.svg')" />
    </ng-container>
    <div class="total-annual-value-container">
      Estimated Annual Revenue:
      <div class="valuation">
        {{ valuePerYear }}
      </div>
    </div>
  </div>

  <div class="main-container">
    <form [formGroup]="submitForm" fcFormUnloadWarning>
      <main class="step-review">
        <div class="review-panel">
          <div class="header">Review & Submit</div>
          <mat-divider></mat-divider>
          <div class="totals">
            <div class="count">
              Forested Acres:
              <span>{{ area }}</span>
            </div>
            <div class="count">
              Number of Stands:
              <span>{{ selectedStandList.length }}</span>
            </div>
            <div class="count">
              Frequency of payments:
              <span>{{ paymentFrequency }}</span>
            </div>
            <div class="future-valuations">
              <div class="future-valuation">
                <span>
                  Total Projection Through {{ twentyYearMark }}:
                  <fa-icon
                    #tooltip1="matTooltip"
                    (click)="tooltip1.toggle()"
                    [icon]="['far', 'circle-info']"
                    [matTooltip]="projectionInfoBox(twentyYearMark)"
                    class="blue"
                    matTooltipClass="fc-tooltip"
                    matTooltipPosition="right"></fa-icon>
                </span>
                <span class="twenty-year-projection">
                  {{ twentyYearProjection }}
                </span>
              </div>
            </div>
          </div>
          <div class="disclaimer">
            Note: Payment amount is based on information provided. Actual payments may vary pending site review and your
            responses to periodic reporting to the CORE Carbon program.
          </div>
          <mat-divider class="hide-tablet"></mat-divider>
        </div>
        <div class="expect-section">
          <div class="what-to-expect">What To Expect After Site Submission</div>
          @if (activeSite.cohort.docusignTemplateId && !activeSite.eDocFulfilled) {
            <div class="step-header">Immediate Action</div>
            <div class="step-text e-doc-required">
              You will receive a request by email with a link an electronic document. Please complete this request
              electronically ASAP. Your site will not be reviewed until this document has been received.
            </div>
          }
          <div class="step-header">Step 1</div>
          <div class="step-text">
            Once submitted, your Carbon Offset Site will be reviewed by our team at CORE Carbon.
            <span *ngIf="appConfigTimeToReview">
              {{ appConfigTimeToReview }}
            </span>
          </div>
          <div class="step-header">Step 2</div>
          <div class="step-text">You will receive an email when your contract documentation is ready.</div>
          <div class="step-header">Step 3</div>
          <div class="step-text">
            Review and sign your contract, and start receiving payments after signing up with our secure third-party
            payment processor.
          </div>
          <div class="disclaimer">
            Note: By submitting your Carbon Offset Site for review, you agree that CORE Carbon may make modifications to
            your Carbon Offset Site based on the CORE Carbon program eligibility requirements. You will be notified of
            any modifications to your Carbon Offset Site and all such modifications will be subject to your review and
            final approval.
          </div>
        </div>
        <div class="review-side-panel">
          <div class="side-header">
            <h2>Your Carbon Offset Site</h2>
          </div>
          <mat-divider></mat-divider>
          <div *ngFor="let selectedStand of selectedStandList; let i = index">
            <fc-site-stand-item
              [allowRemove]="false"
              [clickable]="false"
              [cohortId]="activeSite.cohortId"
              [index]="i"
              [stand]="selectedStand"></fc-site-stand-item>
          </div>
        </div>
        <div class="legal-ack">
          <mat-checkbox class="legalAck" data-cy="legal-ack" formControlName="legalAck" id="legalAck">
            {{ LegalConstants.QUESTION_DISCLAIMER }}
          </mat-checkbox>
        </div>
      </main>

      <div class="button-area">
        <div>
          <button
            (click)="submitSite()"
            [disabled]="!submitForm.valid"
            color="primary"
            data-cy="button-primary"
            mat-raised-button>
            <span>Submit Site</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
